import { FC } from 'react';

import styles from './content-hub-share-icons.module.scss';
import { getTooltipMessage, getUrlShare, handlePopupCenter } from './content-hub-share-icons.utils';
import IconFacebook from './social-and-share-icon/facebook-social';
import IconLinkedIn from './social-and-share-icon/linkedIn-social';
import IconTwitter from './social-and-share-icon/twitter-social';

interface Props {
  shareUrl?: string;
}

interface ButtonItem {
  type: string;
  urlShare: string;
  compShare: React.ReactElement<any>;
}

const socialAndShares = [
  { type: 'facebook', urlShare: '', compShare: <IconFacebook /> },
  { type: 'linkedIn', urlShare: '', compShare: <IconLinkedIn /> },
  { type: 'twitter', urlShare: '', compShare: <IconTwitter /> },
];

const SocialAndShare: FC<Props> = (props) => {
  const { shareUrl } = props;

  return (
    <div className={styles.container}>
      {(socialAndShares || []).map((item: ButtonItem) => {
        const linkShare = getUrlShare(item.type, item.urlShare || shareUrl!);

        return (
          <div
            key={item.type}
            className={styles.socialAndShareLink}
            onClick={() => {
              handlePopupCenter({
                url: linkShare,
                title: getTooltipMessage(item.type),
                popupWidth: 400,
                popupHeight: 300,
              });
            }}
          >
            {item.compShare}
            <span className={styles.socialAndShareTooltip}>{getTooltipMessage(item.type)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default SocialAndShare;
